(async function () {
  const {
    handleIncreaseQuantity,
    handleDecreaseQuantity,
    updateCartBubble,
    removeFromCart,
    getCart,
  } = await import('./cart-functions.js');
  // Module function to make the API call
  // global states
  let productCartFlowInProgress = true;
  let orderHistoryFlowInProgress = false;
  let isRefreshSession = false;
  let UiUpdateInProgress = false;
  let cart_count = 0;

  function updateCartCountBubble(count) {
    const cartCountBubble = document.querySelector('.cart-count-bubble');

    if (cartCountBubble) {
      cartCountBubble.innerText = count || 0;
      cartCountBubble.style.display = count > 0 ? 'block' : 'none'; // Hide if empty
    } else {
      const cartIconContainer = document.querySelector('#cart-icon-bubble');

      if (cartIconContainer) {
        // Create the cart count bubble element
        const bubbleDiv = document.createElement('div');
        bubbleDiv.className = 'cart-count-bubble count';

        const bubbleSpan = document.createElement('span');
        bubbleSpan.setAttribute('aria-hidden', 'true');
        bubbleSpan.innerText = count || 0;

        // Append the span to the div
        bubbleDiv.appendChild(bubbleSpan);

        // Append the bubble to the cart icon container
        cartIconContainer.appendChild(bubbleDiv);
      }
    }
  }

  async function addToCart(variantId, freebiesLevel, quantity = 1) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: quantity,
        sections: 'cart-drawer,cart-icon-bubble',
        id: variantId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        window.dataLayer?.push({
          event: 'bot_error',
          bot_name: 'Chatbot X',
          error: error,
        });
        throw error;
      });
  }

  
 async function reduceCartItem(lineItemId, quantity = 1) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemId, 
      quantity: quantity, 
      sections: 'cart-drawer,cart-icon-bubble'
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      updateCartBubble(); // Refresh the cart UI
      return data;
    })
    .catch((error) => {
      console.error('Error updating cart item:', error);
      window.dataLayer?.push({
        event: 'bot_error',
        bot_name: 'Chatbot X',
        error: error,
      });
     throw error;
    });
}



  function getUserLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) =>
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }),
          (error) => reject(error)
        );
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  function getNearestShop(userLocation, shops) {
    let nearestShop = null;
    let minDistance = Infinity;

    shops.forEach((shop) => {
      const distance = haversineDistance(userLocation, {
        lat: shop.latitude,
        lng: shop.longitude,
      });
      if (distance < minDistance) {
        minDistance = distance;
        nearestShop = shop;
      }
    });

    return nearestShop;
  }

  // Haversine Formula to Calculate Distance
  function haversineDistance(coord1, coord2) {
    const R = 6371; // Earth's radius in km
    const toRad = (deg) => (deg * Math.PI) / 180;

    const dLat = toRad(coord2.lat - coord1.lat);
    const dLng = toRad(coord2.lng - coord1.lng);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(coord1.lat)) *
        Math.cos(toRad(coord2.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  }

  function getGoogleMapsDirectionsLink(shop) {
    const baseUrl = 'https://www.google.com/maps/dir/?api=1';
    const destination = `${shop.latitude},${shop.longitude}`;
    return `${baseUrl}&destination=${destination}`;
  }

  function displayNearestShopOnMap(shop, messageBlock) {
    const storeAddress = `Store Address: ${shop.store}, ${shop.address}`;
    const botMessage = document.createElement('div');
    botMessage.classList.add('bot-message');
    botMessage.innerHTML = `<p>${storeAddress}</p>`;

    const botMessage2 = document.createElement('div');
    botMessage2.classList.add('bot-message');
    botMessage2.innerHTML = `<a href="${getGoogleMapsDirectionsLink(
      shop
    )}" target="_blank" style="color: blue; text-decoration: underline;">
      (Get Directions): ${shop.store}</a>`;

    const botMessage3 = document.createElement('div');
    botMessage3.classList.add('bot-message');
    botMessage3.innerHTML = `<a href="tel:${shop.phone}" style="color: blue; text-decoration: underline;">
      Phone Number: ${shop.phone}</a>`;

    const mapContainer = document.createElement('div');
    mapContainer.classList.add('map-container');

    const chatMessages = document.querySelector('.chat-messages');
    const botMessages = messageBlock.querySelector('.bot-messages');

    botMessages.innerHTML = '';
    botMessages.classList.add('loaded');
    botMessages.appendChild(botMessage);
    botMessages.appendChild(botMessage2);
    botMessages.appendChild(botMessage3);
    // chatMessages.appendChild(botMessages);
    chatMessages.appendChild(mapContainer);

    // Initialize Google Map with Map ID
    const map = new google.maps.Map(mapContainer, {
      center: { lat: shop.latitude, lng: shop.longitude },
      zoom: 14,
      mapId: '35e6a37fb5d6a42b', // Add your Map ID here
    });

    google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
      setTimeout(() => {
        google.maps.event.trigger(map, 'resize');
      }, 500);
    });

    // Use AdvancedMarkerElement if available
    if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
      new google.maps.marker.AdvancedMarkerElement({
        position: { lat: shop.latitude, lng: shop.longitude },
        map,
        title: shop.store,
      });
    } else {
      console.warn(
        'AdvancedMarkerElement is not available. Falling back to Marker.'
      );
      new google.maps.Marker({
        position: { lat: shop.latitude, lng: shop.longitude },
        map,
        title: shop.store,
      });
    }
    return map;
  }

  async function findAndShowNearestShop() {
    const botMessages = document.createElement('div');
    botMessages.classList.add('bot-messages', 'loading');

    let loader = getLoader();
    toggleChatInput(true);
    const messageBlock = createLoaderItem(loader, botMessages);
    try {
      const response = await fetch(window.shopsUrl);
      const shops = await response.json();
      const userLocation = await getUserLocation();

      const nearestShop = getNearestShop(userLocation, shops);

      if (nearestShop) {
        return displayNearestShopOnMap(nearestShop, messageBlock);
      } else {
        console.log('No shop found!');
      }
    } catch (error) {
      const botMessages = messageBlock.querySelector('.bot-messages');
      botMessages.innerHTML = '';
      botMessages.classList.add('loaded');
      const botMessage = document.createElement('div');
      botMessage.classList.add('bot-message');
      botMessage.innerHTML = `Please allow location access to see closest shop`;
      botMessages.appendChild(botMessage);
      window.dataLayer?.push({
        event: 'bot_error',
        bot_name: 'Chatbot X',
        error: error
      });
    }
  }

  async function saveTranscript() {
    const userID = JSON.parse(sessionStorage.getItem('voiceFlowuserID'));

    const url = 'https://api.voiceflow.com/v2/transcripts';

    const payload = {
      projectID: '67b5fed2b6d15e398234924f',
      versionID: '67b5fed2b6d15e3982349250',
      sessionID: userID,
    };

    const headers = {
      accept: 'application/json',
      'content-type': 'application/json',
      Authorization: 'VF.DM.67b72f69fba003864eef501a.hjoIAK4lwj9Ip1E7',
    };

    if (userID && typeof userID === 'string' && userID.trim() !== '') {
      try {
        const response = await fetch(url, {
          method: 'PUT',
          headers: headers,
          body: JSON.stringify(payload),
        });
      } catch (error) {
        console.error('Error saving transcript:', error);
      }
    }
  }

  async function interactWithVoiceflow(action, config = {}, state = {}) {
    UiUpdateInProgress = true;
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: 'VF.DM.67b72f69fba003864eef501a.hjoIAK4lwj9Ip1E7',
      },
      body: JSON.stringify({
        action: action,
        config: {
          tts: false,
          stripSSML: true,
          stopAll: false,
          excludeTypes: ['block', 'debug', 'flow'],
          ...config, // Merge custom config
        },
        state, // Include state if needed
      }),
    };
    const userID = JSON.parse(sessionStorage.getItem('voiceFlowuserID'));
    try {
      const start = Date.now(); 
      const response = await fetch(
        `https://general-runtime.voiceflow.com/state/user/${userID}/interact?logs=off`,
        options
      );
      const data = await response.json();
      const latency = Date.now() - start;

      window.dataLayer?.push({
        event: 'bot_latency_ms',
        bot_name: 'Chatbot X',
        data: {
          latency, userID
        },
      });

      if (data == null || data == '' || data.length === 0) throw new Error('');
      return data;
    } catch (error) {
      // console.error('Error interacting with Voiceflow:', error);
      try {
        const bestSellersOptions = {
          ...options,
          body: JSON.stringify({
            action: {
              type: 'intent',
              payload: {
                query: 'Show me your best sellers',
                intent: {
                  name: 'Best Sellers',
                },
                confidence: 0.5,
              },
            },
            config: {
              tts: false,
              stripSSML: true,
              stopAll: false,
              excludeTypes: ['block', 'debug', 'flow'],
              ...config,
            },
            state,
          }),
        };  
        
        const start = Date.now(); 
        const response = await fetch(
          `https://general-runtime.voiceflow.com/state/user/${userID}/interact?logs=off`,
          bestSellersOptions
        );
        const data = await response.json();
        const latency = Date.now() - start;

         window.dataLayer?.push({
           event: 'bot_latency_ms',
           bot_name: 'Chatbot X',
           data: {
             latency,
             userID,
           },
         });
        return data;
      } catch (error2) {
        console.error('Error interacting with Voiceflow:', error2);
        UiUpdateInProgress = false;
        return null;
      }
    }
  }

  function getLastBotMessage() {
    const botMessages = document.querySelectorAll('.bot-messages');
    if (botMessages.length > 0) {
      return botMessages[botMessages.length - 1].innerHTML.trim();
    }
    return null;
  }

  // Function to check if the input is an email
  function isEmail(text) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(text);
  }

  function interactWithEvent(email) {
    document.querySelector('.button-container').innerHTML = '';
    let loader = getLoader();
    if (email) {
      if (!window.loggedInUser) {
        window.loggedInUser = {};
      }
      window.loggedInUser.email = email;
    }
    const variable = email
      ? {
          variables: {
            email_address: email,
            cart_count: cart_count,
          },
        }
      : {
          cart_count: cart_count,
        };
    const botMessages = document.createElement('div');
    botMessages.classList.add('bot-messages', 'loading');
    const messageBlock = createLoaderItem(loader, botMessages);
    interactWithVoiceflow(
      { type: 'event', payload: { event: { name: 'RegisterEmail' } } },
      {},
      variable
    ).then((response) => {
      // Update the chat UI with the response
      if (response) {
        setTimeout(() => {
          updateChatUI(response, messageBlock).then(() =>
            toggleChatInput(false)
          );
          botMessages.classList.add('loaded');
          if (!window.loggedInUser) {
            window.loggedInUser = {};
          }
          window.loggedInUser.email = email;
        }, 500);
      }
    });
  }

  // Function to render product cards
  async function renderProductCards(productCards) {
    return getCart()
      .then((cartData) => {
        const cartCountBubble = document.querySelector('.cart-count-bubble');
        if (cartCountBubble && cartData) {
          cartCountBubble.innerText = cartData.item_count;
          cartCountBubble.style.display =
            cartData.item_count > 0 ? 'block' : 'none';
        }
        return cartData;
      })
      .then((cartData) => {
        var productCardsContainer = document.createElement('div');
        productCardsContainer.classList.add('bot-product-cards-container');
        productCardsContainer.innerHTML = `
      <div class="bot-product-cards-wrapper"><div class="bot-product-cards-container"></div></div>
      `;

        var cardsContainer = productCardsContainer.querySelector(
          '.bot-product-cards-container'
        );

        productCards.forEach(function (product) {
          var card = document.createElement('div');
          card.className = 'bot-product-card';

          var score = parseFloat(product.product_score) || 0;
          var fullStars = Math.floor(score);
          var hasHalfStar = score - fullStars >= 0.5;
          var starsHTML = '';

          for (var i = 0; i < 5; i++) {
            if (i < fullStars) {
              starsHTML += '★';
            } else if (i === fullStars && hasHalfStar) {
              starsHTML += '★';
            } else {
              starsHTML += '☆';
            }
          }

          // cart item
          let cartItemInfo = null;
          const productVariantId = product.variantId;
          if (cartData && productVariantId) {
            const cartItem = cartData.items.find(
              (item) =>
                item.variant_id.toString() === productVariantId.toString()
            );

            if (cartItem) {
              cartItemInfo = {
                quantity: cartItem.quantity,
                lineItemId: cartItem.key || cartItem.id,
              };
            }
          }
          // const url = new URL(product.link);
          // const path = url.pathname.substring(1);
          const isStock = product?.inventory_quantity
            ? product.inventory_quantity > 0
              ? true
              : false
            : true; // await CheckProductInStock(path)
          if (!isStock) product.price = '(Out of Stock)';
          card.innerHTML = `
          <div class="chatbot-product-image-container">
            <img class="chatbot-product-image" src="${product.image}" alt="${
            product.title
          }">
          </div>
          <div class="chatbot-product-info">
            <div class="product-title">${product.title}</div>
           <div class="product-price">
              ${
                product.price === '(Out of Stock)'
                  ? '(Out of Stock)'
                  : `$${product.price.replace('$', '')}`
              }
           </div>
            <div class="product-rating">
              <span class="product-stars" data-product-score="${
                product.product_score
              }">${starsHTML}</span>
              <span class="product-review">(${
                product.total_reviews || 0
              })</span>
            </div>
            <div class="chatbot-product-description">${
              product.description
            }</div>
            <div class="chatbot-product-button-container">
              <button class="bot-add-to-cart-btn" data-variant-id="${productVariantId}">Add To Cart</button>
              <div class="bot-quantity-control" data-variant-id="${productVariantId}">
                <button class="bot-quantity-btn bot-decrease-btn">-</button>
                <span class="quantity-display">1</span>
                <button class="bot-quantity-btn bot-increase-btn">+</button>
              </div>
            </div>
          </div>
        `;
          if (product.price === '(Out of Stock)') {
            // Disable "Add to Cart" button
            const atcButton = card.querySelector('.bot-add-to-cart-btn');
            atcButton.disabled = true;
            atcButton.style.opacity = '0.5';
            atcButton.style.cursor = 'not-allowed';

            // Disable quantity control buttons
            card.querySelectorAll('.bot-quantity-btn').forEach((button) => {
              button.disabled = true;
              button.style.opacity = '0.5';
              button.style.cursor = 'not-allowed';
            });
          }

          cardsContainer.appendChild(card);

          var addToCartBtn = card.querySelector('.bot-add-to-cart-btn');
          var decreaseBtn = card.querySelector('.bot-decrease-btn');
          var increaseBtn = card.querySelector('.bot-increase-btn');
          var quantityDisplay = card.querySelector('.quantity-display');
          const quantityControl = card.querySelector('.bot-quantity-control');
          const variantId = addToCartBtn.getAttribute('data-variant-id');

          const productImage = card.querySelector('.product-image');

          if (productImage) {

              productImage.addEventListener('click', () => {
                 window.dataLayer?.push({
                   event: 'bot_suggestion_clicked',
                   bot_name: 'Chatbot X',
                   data: {
                     variantId,
                   },
                 });
              });
          }


          if (cartItemInfo) {
            quantityDisplay.textContent = cartItemInfo.quantity;
            addToCartBtn.classList.add('hide-btn');
            quantityControl.classList.add('show-quantity');
            quantityControl.setAttribute(
              'data-line-item-id',
              cartItemInfo.lineItemId
            );
          }

          addToCartBtn.addEventListener('click', function (event) {
            event.target.classList.add('hide-btn');

            window.dataLayer?.push({
              event: 'bot_add_to_cart',
              bot_name: 'Chatbot X',
              data: {
                variantId,
              },
            });

            quantityControl.classList.add('show-quantity');
            const freebiesLevel = card.querySelector('.freebies-add-to-cart')
              ? freebiesButton.getAttribute('data-freebies_level')
              : null;
            addToCart(variantId, freebiesLevel, 1)
              .then((data) => {
                
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "chat-bot",
                    productVariantId: variantId,
                    cartData: data,
                });
                
                const cart = document.querySelector("cart-drawer");
                cart.renderContentsWithoutOpen(data);
                if (cart && cart.classList.contains('is-empty'))
                  cart.classList.remove('is-empty');
                
                const emty = document.querySelector('.drawer__inner-empty');
                if (emty) emty.style.display = 'none';
                
                
                // Store the line item ID for future cart operations
                getCart().then((newCartData) => {
                  if (newCartData && newCartData.items) {
                    updateCartCountBubble(newCartData.item_count);
                    cart_count = newCartData.item_count;
                    const addedItem = newCartData.items.find(
                      (item) =>
                        item.variant_id.toString() === variantId.toString()
                    );
                    if (addedItem) {
                      quantityControl.setAttribute(
                        'data-line-item-id',
                        addedItem.key || addedItem.id
                      );
                    }
                  }
                  if (
                    !window?.loggedInUser?.email &&
                    productCartFlowInProgress
                  ) {
                    // let buttonContainer = document.querySelector('.button-container');
                    // buttonContainer.innerHTML = '';
                    const checkUiUpdate = () => {
                      if (UiUpdateInProgress) {
                        // If flag is true, check again after a short delay
                        setTimeout(checkUiUpdate, 1000); // 100ms delay between checks
                      } else {
                        // When flag becomes false, proceed with your logic
                        interactWithEvent('');
                        productCartFlowInProgress = false;
                      }
                    };

                    // Start checking the flag
                    checkUiUpdate();
                  }
                  // cart.renderContents(newCartData);
                  // const cartTotalElement = document.querySelector("[data-total-value]");
                  // cartTotalElement.setAttribute("data-total-value", cartTotalElement.getAttribute("data-total-value") + data.final_line_price);
                  // const cartTotal =  parseFloat(cartTotalElement.getAttribute("data-total-value")) / 100;
                  // console.log("total cart value", cartTotal);
                  // document.querySelector('.progress-bar-container')?.classList.remove('hidden');
                  // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: newCartData, variantId: variantId });
                  //
                  // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: newCartData, variantId: variantId });
                });
              })
              .catch((error) => {
                console.error('Failed to add item to cart:', error);
                // Revert UI changes if API call fails
                event.target.classList.remove('hide-btn');
                quantityControl.classList.remove('show-quantity');
              });
          });

          decreaseBtn.addEventListener('click', function (event) {
            event.target.disabled = false;
            var lineItemId =
              quantityControl.getAttribute('data-line-item-id') || variantId;

            let quantity = parseInt(quantityDisplay.textContent);

            if (quantity > 1) {
              // Decrease quantity if more than 1
              const newQuantity = quantity - 1;

              // Update UI optimistically
              quantityDisplay.textContent = newQuantity;

              // Update cart via API
              if (lineItemId) {
                reduceCartItem(lineItemId, newQuantity)
                  .then((data) => {
                    event.target.disabled = false;
                    cart_count = cart_count - 1;
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'chat-bot',
                      cartData: data,
                    });

                    const cart = document.querySelector("cart-drawer");
                    cart.renderContentsWithoutOpen(data);
                    
                  })
                  .catch((error) => {
                    // Revert UI changes if API call fails
                    quantityDisplay.textContent = quantity;
                  });
              }
            } else {
              // Update UI optimistically
              addToCartBtn.classList.remove('hide-btn');
              quantityControl.classList.remove('show-quantity');

              // Reset quantity to 1
              const quantityDisplay =
                quantityControl.querySelector('.quantity-display');
              if (quantityDisplay) {
                quantityDisplay.textContent = '1';
              }

              // Remove from cart via API
              if (lineItemId) {
                reduceCartItem(lineItemId, 0)
                  .then((data) => {

                    event.target.disabled = false;
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'chat-bot',
                      cartData: data,
                    });
                    const cart = document.querySelector('cart-drawer');
                    cart.renderContentsWithoutOpen(data);
                        
                    getCart().then((newCartData) => {
                      // event.target.disabled = false;
                      // publish(PUB_SUB_EVENTS.cartUpdate, {
                      //   source: 'chat-bot',
                      //   cartData: newCartData,
                      // });

                      if (newCartData.items.length === 0) {
                        cart_count = newCartData.item_count;
                        
                        if (cart && !cart.classList.contains('is-empty')) {
                          cart.classList.add('is-empty');
                        }
                        const cartDrawer = document.querySelector(
                          '.drawer__inner-empty'
                        );
                        if (cartDrawer) {
                          cartDrawer.style.display = 'flex';
                        }
                      }
                    });
                  })
                  .catch((error) => {
                    // Revert UI changes if API call fails
                    addToCartBtn.classList.add('hide-btn');
                    quantityControl.classList.add('show-quantity');
                    event.target.disabled = false;
                  });
              }
            }
          });

          increaseBtn.addEventListener('click', function (event) {
            let quantity = parseInt(quantityDisplay.textContent);
            quantity++;
            quantityDisplay.textContent = quantity;
            event.target.disabled = true;
            // Update cart via API
            if (variantId) {
              addToCart(variantId, 1)
                .then((data) => {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'chat-bot',
                    cartData: data,
                  });
                  
                  const cart = document.querySelector("cart-drawer");
                  cart.renderContentsWithoutOpen(data);
                  
                  getCart()
                    .then(function (updatedCart) {
                      cart_count = updatedCart.item_count;
                
                      updateCartCountBubble(updatedCart.item_count);
                      var updatedItem = updatedCart.items.find(function (item) {
                        return (
                          item.variant_id.toString() === variantId.toString()
                        );
                      });
                      event.target.disabled = false;
                      if (updatedItem) {
                        quantityControl.setAttribute(
                          'data-line-item-id',
                          updatedItem.key || updatedItem.id
                        );
                      }
                    })
                    .catch(function (error) {
                      console.error('Error updating line item ID:', error);
                    });
                })
                .catch((error) => {
                  // Revert UI changes if API call fails
                  quantity--;
                  quantityDisplay.textContent = quantity;
                  event.target.disabled = false;
                });
            }
          });
        }); // Add swipe functionality

        let currentIndex = 0;
        const totalCards = productCards.length; // Function to update the display

        function updateDisplay() {
          const cardWidth =
            cardsContainer.querySelector('.bot-product-card').offsetWidth;
          const cardMargin = 15; // Gap between cards
          const scrollPosition = currentIndex * (cardWidth + cardMargin);
          cardsContainer.style.transform = `translateX(-${scrollPosition}px)`;
        } // Initialize display

        updateDisplay(); // Touch swipe functionality

        let touchStartX = 0;
        let touchEndX = 0;

        const wrapper = productCardsContainer.querySelector(
          '.bot-product-cards-wrapper'
        );

        const leftArrow = document.createElement('div');
        leftArrow.className = 'arrow left-arrow';
        leftArrow.innerHTML = '&#10094;';

        const rightArrow = document.createElement('div');
        rightArrow.className = 'arrow right-arrow';
        rightArrow.innerHTML = '&#10095;';

        productCardsContainer.appendChild(leftArrow);
        productCardsContainer.appendChild(rightArrow);

        leftArrow.addEventListener('click', () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateDisplay();
          }
        });

        // Right arrow click event
        rightArrow.addEventListener('click', () => {
          if (currentIndex < totalCards - 1) {
            currentIndex++;
            updateDisplay();
          }
        });

        wrapper.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );

        wrapper.addEventListener(
          'touchend',
          (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
          },
          { passive: true }
        ); // For desktop/mouse users

        let isDragging = false;
        let startX = 0;

        wrapper.addEventListener('mousedown', (e) => {
          isDragging = true;
          startX = e.clientX;
          wrapper.style.cursor = 'grabbing';
        });

        wrapper.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          e.preventDefault();
        });

        wrapper.addEventListener('mouseup', (e) => {
          if (!isDragging) return;

          const endX = e.clientX;
          const diffX = endX - startX;

          if (Math.abs(diffX) > 50) {
            if (diffX > 0 && currentIndex > 0) {
              // Swiped right
              currentIndex--;
            } else if (diffX < 0 && currentIndex < totalCards - 1) {
              // Swiped left
              currentIndex++;
            }
            updateDisplay();
          }

          isDragging = false;
          wrapper.style.cursor = 'grab';
        });

        wrapper.addEventListener('mouseleave', () => {
          isDragging = false;
          wrapper.style.cursor = '';
        });

        function handleSwipe() {
          const SWIPE_THRESHOLD = 50;
          const diffX = touchEndX - touchStartX;

          if (Math.abs(diffX) > SWIPE_THRESHOLD) {
            if (diffX > 0 && currentIndex > 0) {
              // Swiped right (previous)
              currentIndex--;
            } else if (diffX < 0 && currentIndex < totalCards - 1) {
              // Swiped left (next)
              currentIndex++;
            }
            updateDisplay();
          }
        }

        return productCardsContainer;
      })
      .catch((error) => {
        console.error('Error fetching initial cart data:', error);
        window.dataLayer?.push({
          event: 'bot_error',
          bot_name: 'Chatbot X',
          error: error
        });
        return;
      });
  }

  function createBotContainer() {
    const botContainer = document.createElement('div');
    botContainer.classList.add('bot-content');
    const botIconContainer = document.createElement('div');
    botIconContainer.classList.add('bot-icon-container');
    botIconContainer.innerHTML = `<img src="${window.botIconUrl}" alt="Bot Icon" class="bot-icon">`;
    botContainer.appendChild(botIconContainer);
    return botContainer;
  }

  async function typeEffect(element, text, parsedMessage, speed = 10) {
    element.innerHTML = '';
    text = text.trim().replace(/\n+$/, ''); // Remove trailing newlines
    text = text.replace(/\\n/g, '\n');
    return new Promise((resolve) => {
      let index = 0;

      function type() {
        if (index < text.length) {
          if (text.charCodeAt(index) === 10) {
            element.innerHTML += '<br>';
          } else {
            element.innerHTML += text.charAt(index);
          }
          index++;
          scrollToLatest();
          setTimeout(type, speed);
        } else {
          element.innerHTML = parsedMessage.trim(); // Remove extra trailing spaces/newlines
          resolve();
        }
      }

      type();
    });
  }

  function decodeHtmlEntities(html) {
    html = html.replace(/<br\s*\/?>/gi, '\n');
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value; // Get the decoded string
  }

  function scrollToLatest() {
    const chatContent = document.querySelector('.chat-content');
    chatContent.scrollTop = chatContent.scrollHeight;
  }

  function formatMarkdown(text) {
    return marked.parse(text.replace(/\n/g, '<br>\n'));
  }

  async function updateChatUI(
    response,
    optionalMesageBlock = null,
    buttonsCopy = ''
  ) {
    const chatContent = document.querySelector('.chat-content');
    const chatMessages = document.querySelector('.chat-messages');
    let buttonContainer = document.querySelector('.button-container');
    buttonContainer.innerHTML = '';
    let botContainer = null;
    let botMessages = null;
    let messageBlock = document.createElement('div');

    if (optionalMesageBlock == null) {
      botContainer = createBotContainer();
      messageBlock.classList.add('message-block');
      botMessages = document.createElement('div');
      botMessages.classList.add('bot-messages');
    } else {
      messageBlock = optionalMesageBlock;
      botMessages = messageBlock.querySelector('.bot-messages');
      botMessages.innerHTML = '';
    }

    let productCarousel = null;

    for (const item of response) {
      if (item.type === 'text') {
        // Add bot message
        const botMessageWrapper = document.createElement('div');
        botMessageWrapper.classList.add('bot-message-wrapper');
        const botMessage = document.createElement('div');
        botMessage.classList.add('bot-message');
        botMessageWrapper.appendChild(botMessage);

        const parsedMessage = formatMarkdown(item.payload.message);
        botMessages.appendChild(botMessage);
        const plainText = decodeHtmlEntities(
          parsedMessage.replace(/<[^>]+>/g, '')
        );
        await typeEffect(
          botMessage,
          JSON.stringify(plainText).replace(/^"|"$/g, ''),
          parsedMessage
        ); // if(parsedMessage.includes("exciting discounts waiting")){
        //   const chatButton = document.createElement('button');
        //   chatButton.classList.add('chat-button');
        //   chatButton.textContent = "Prefer not to give";
        //   chatButton.onclick = (() => {
        //     buttonContainer.innerHTML = "";
        //     sendMessage("Prefer not to give");
        //   });
        //   buttonContainer.appendChild(chatButton);
        // }
      } else if (item.type === 'choice') {
        // Add buttons
        item.payload.buttons.forEach((button) => {
          const chatButton = document.createElement('button');
          chatButton.classList.add('chat-button');
          chatButton.textContent = button.name;
          chatButton.setAttribute(
            'data-request',
            JSON.stringify({
              type: button.request.type,
              payload: button.request.payload,
            })
          );
          chatButton.onclick = () => {
            selectCustomer(button.request, button.name);
          };
          buttonContainer.appendChild(chatButton);
        });
      } else if (item.type === 'product_cards') {
        // Render product cards
        console.log('cards', item.payload);
        productCarousel = renderProductCards(item.payload.lineitems);
      } else if (item.type === 'checkout') {
    
        window.dataLayer?.push({
          event: 'bot_begin_checkout',
          bot_name: 'Chatbot X',
        });

        setTimeout(function () {
          var win = window.open(item.payload.link, '_blank');
          if (!win || win.closed || typeof win.closed == 'undefined') {
            window.location.href = item.payload.link;
          }
        }, 2000);
      }
    } // Append the new bot messages to the message block

    if (productCarousel == null && botContainer) {
      botContainer.appendChild(botMessages);
      messageBlock.appendChild(botContainer);
      chatMessages.appendChild(messageBlock);
    }

    if (productCarousel) {
      buttonContainer.style.display = 'none'; // Hide buttons initially
      productCarousel
        .then((data) => {
          if (data) {
            if (botContainer) {
              botContainer.appendChild(botMessages);
              messageBlock.appendChild(botContainer);
              chatMessages.appendChild(messageBlock);
            }
            messageBlock.appendChild(data); // Append product cards
          }
        })
        .then(() => {
          buttonContainer.style.display = 'flex'; // Show buttons after product cards are rendered
          chatMessages.appendChild(buttonContainer); // Append buttons
          // Scroll to the bottom of the chat
          setTimeout(() => {
            smoothScrollTo(chatContent, chatContent.scrollHeight - 250);
          }, 100);
          // Save chat history
          saveChatHistory();
        });
    } else {
      if (botContainer) {
        botContainer.appendChild(botMessages);
        messageBlock.appendChild(botContainer);
        chatMessages.appendChild(messageBlock);
      }
      if (optionalMesageBlock == null) {
        chatMessages.appendChild(messageBlock);
      }
      chatMessages.appendChild(buttonContainer);
      chatContent.scrollTop = chatContent.scrollHeight;
      saveChatHistory();
    }
    UiUpdateInProgress = false;
  }

  function smoothScrollTo(chatContent, targetPosition) {
    const startPosition = chatContent.scrollTop;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animationStep(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const duration = 1200; // Adjust this value for a slower effect (800ms = 0.8s)

      // Ease function (ease-out effect)
      const ease =
        elapsed / duration < 1 ? 1 - Math.pow(1 - elapsed / duration, 3) : 1;

      chatContent.scrollTop = startPosition + distance * ease;

      if (elapsed < duration) {
        requestAnimationFrame(animationStep);
      }
    }

    requestAnimationFrame(animationStep);
  }

  function addUserMessage(message, isLoadOnRefresh = false) {
    const chatMessages = document.querySelector('.chat-messages'); // Create a new message block for the user's response

    const userMessageBlock = document.createElement('div');
    userMessageBlock.classList.add('message-block');
    userMessageBlock.style.justifyContent = 'flex-end'; // Align user messages to the right // Add user message

    const userMessage = document.createElement('div');
    userMessage.classList.add('user-message');
    userMessage.textContent = message;
    userMessageBlock.appendChild(userMessage); // Append the user message block to the chat messages container

    chatMessages.appendChild(userMessageBlock); // Scroll to the bottom of the chat

    const chatContent = document.querySelector('.chat-content');
    chatContent.scrollTop = chatContent.scrollHeight;

    if (!isLoadOnRefresh) saveChatHistory();
  }

  function getLoader() {
    const loader = document.createElement('div');
    loader.innerHTML = `
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  `;
    loader.classList.add('dot-loader');
    return loader;
  }

  function createLoaderItem(loader, botMessages) {
    const chatMessages = document.querySelector('.chat-messages');
    const botContainer = createBotContainer();
    const messageBlock = document.createElement('div');
    messageBlock.classList.add('message-block');

    const botMessage = document.createElement('div');
    botMessage.classList.add('bot-message');

    botMessage.appendChild(loader);
    botMessages.appendChild(botMessage);
    botContainer.appendChild(botMessages);
    messageBlock.appendChild(botContainer);
    chatMessages.appendChild(messageBlock);
    return messageBlock;
  }

  function toggleChatInput(disabled) {
    const input = document.getElementById('messageInput');
    const button = document.querySelector('.send-btn');
    // const refresh = document.querySelector(".refresh-btn");

    input.disabled = disabled;
    button.disabled = disabled;
    // refresh.disabled = disabled;
  }

  async function selectCustomer(request, buttonText) {
    if (!request) return;

    if (buttonText.toLowerCase().includes('order history')) {
      orderHistoryFlowInProgress = true;
    } // Add the button text as a user message

    buttonContainer = document.querySelector('.button-container');
    const sessionButtons =
      JSON.parse(sessionStorage.getItem('chatHistory')) || [];
    // let buttonsCopy = "";
    // for (let i = sessionButtons.length - 1; i >= 0; i--) {
    //     if (sessionButtons[i].buttons) { // Check if 'buttons' key exists
    //         buttonsCopy = sessionButtons[i];
    //         break; // Stop at the first found occurrence
    //     }
    // }
    buttonContainer.innerHTML = '';
    toggleChatInput(true);
    addUserMessage(buttonText); // Extract the action from the request

    const action = {
      type: request.type,
      payload: request.payload,
    };

    if (buttonText.includes('Nearest Shop')) {
      findAndShowNearestShop().then(async (map) => {
        // Create loader and message block
        let loader = getLoader();

        const botMessages = document.createElement('div');
        botMessages.classList.add('bot-messages', 'loading');

        const messageBlock = createLoaderItem(loader, botMessages);

        const chatContent = document.querySelector('.chat-content');
        chatContent.scrollTop = chatContent.scrollHeight;

        // Make the API call with the extracted action

        const variable = {
          variables: {
            cart_count: cart_count,
          },
        };
        const response = await interactWithVoiceflow(action, {}, variable);

        if (response) {
          botMessages.classList.remove('loading');
          setTimeout(() => {
            updateChatUI(response, messageBlock).then(() => {
              toggleChatInput(false);
              requestAnimationFrame(() => {
                google.maps.event.trigger(map, 'resize');
              });
            });

            botMessages.classList.add('loaded'); // Trigger fade-in animation
          }, 500); // Match the duration of the CSS transition
        }
      });
    } else {
      // Create loader and message block
      let loader = getLoader();

      const botMessages = document.createElement('div');
      botMessages.classList.add('bot-messages', 'loading');

      const messageBlock = createLoaderItem(loader, botMessages);

      const chatContent = document.querySelector('.chat-content');
      chatContent.scrollTop = chatContent.scrollHeight;

      // Make the API call with the extracted action

      const variable = {
        variables: {
          cart_count: cart_count,
        },
      };
      const response = await interactWithVoiceflow(action, {}, variable);

      if (response) {
        botMessages.classList.remove('loading');
        setTimeout(() => {
          updateChatUI(response, messageBlock).then(() =>
            toggleChatInput(false)
          );
          botMessages.classList.add('loaded'); // Trigger fade-in animation
        }, 500); // Match the duration of the CSS transition
      }
    }
  }

  async function sendMessage(userMessage) {
    const messageInput = document.getElementById('messageInput');
    const buttonContainer = document.querySelector('.button-container');
    buttonContainer.innerHTML = '';

    // send event
    window.dataLayer?.push({
      event: 'bot_msg',
      bot_name: 'Chatbot X',
      data: {
        message: userMessage
      },
    });

    const lastBotMessage = getLastBotMessage();
    const orderHistoryFlow =
      lastBotMessage && lastBotMessage.toLowerCase().includes('order history');
    const isMail = isEmail(userMessage); // Add user message to the chat

    addUserMessage(userMessage); // Clear the input field
    messageInput.value = '';
    toggleChatInput(true);
    if (
      isMail &&
      !window.loggedInUser?.email &&
      !orderHistoryFlowInProgress &&
      isRefreshSession
    ) {
      interactWithEvent(userMessage);
    } else {
      if (isMail) {
        if (!window.loggedInUser) {
          window.loggedInUser = {};
        }
        window.loggedInUser.email = userMessage;
        if (orderHistoryFlowInProgress) orderHistoryFlowInProgress = false;
      }
      let loader = getLoader();

      const botMessages = document.createElement('div');
      botMessages.classList.add('bot-messages', 'loading');

      const messageBlock = createLoaderItem(loader, botMessages);

      const chatContent = document.querySelector('.chat-content');
      chatContent.scrollTop = chatContent.scrollHeight; // Make the API call to Voiceflow

      interactWithVoiceflow({
        type: 'text',
        payload: userMessage,
      }).then(function (response) {
        if (response) {
          botMessages.classList.remove('loading');
          setTimeout(() => {
            updateChatUI(response, messageBlock).then(() =>
              toggleChatInput(false)
            );
            botMessages.classList.add('loaded');
          }, 500);
        }
      });
    }
  }

  function handleUserInput() {
    const messageInput = document.getElementById('messageInput');
    const sendButton = document.querySelector('.send-btn'); //const refreshButton = document.querySelector('.refresh-btn');
    const closeButton = document.querySelector('.chat-close-btn');
    const popup = document.getElementById('chatConfirmationPopup');
    const confirmButton = document.getElementById('confirmChat');
    const cancelButton = document.getElementById('cancelChat'); // Send message on Enter key press

    messageInput.addEventListener('keypress', async (e) => {
      if (e.key === 'Enter') {
        const userMessage = messageInput.value.trim();
        if (userMessage) {
          sendMessage(userMessage);
        }
      }
    });

    closeButton.addEventListener('click', function () {
      const chatbotContainer = document.getElementById('chatbot-container');
      chatbotContainer.classList.remove('active');
      enableBodyScroll();
    }); // // Send message on button click

    sendButton.addEventListener('click', async () => {
      const userMessage = messageInput.value.trim();
      if (userMessage) {
        sendMessage(userMessage);
      }
    }); // refreshButton.addEventListener('click', () => {
    //   popup.classList.add("active"); // });

    // Handle Confirm Button Click
    // confirmButton.addEventListener("click", function () {
    //     popup.classList.remove("active");
    //     const chatContent = document.querySelector(".chat-messages");
    //     if(chatContent) chatContent.innerHTML = `<div class="button-container"></div>`;
    //     sessionStorage.removeItem('chatHistory');

    //     let loader = getLoader();
    //     toggleChatInput(true);

    //     const botMessages = document.createElement('div');
    //     botMessages.classList.add('bot-messages', 'loading');

    //     const messageBlock = createLoaderItem(loader, botMessages);

    //     interactWithVoiceflow({ type: 'launch'}, {}, {
    //           "variables": {
    //             "email_address": window?.loggedInUser?.email ?? "chatbot@kingpalm.com"
    //           }
    //       }).then(function (response) {
    //       if (response) {
    //          setTimeout(() => {
    //             updateChatUI(response, messageBlock).then(()=>toggleChatInput(false));
    //             botMessages.classList.add('loaded'); // Trigger fade-in animation
    //           }, 500);
    //       }
    //     });
    // });

    // Handle Cancel Button Click
    // cancelButton.addEventListener("click", function () {
    //   popup.classList.remove("active");
    // });
  } // Function to save chat history to sessionStorage

  function saveChatHistory() {
    const chatMessages = document.querySelector('.chat-messages');
    const chatHistory = [];

    var messageBlocks = chatMessages.querySelectorAll('.message-block'); // Loop through all message blocks
    messageBlocks.forEach((messageBlock, index) => {
      const isUserMessage = messageBlock.style.justifyContent === 'flex-end';
      var buttonsAdded = false;
      if (isUserMessage) {
        // Save user message
        const messageContent =
          messageBlock.querySelector('.user-message')?.textContent;
        if (messageContent) {
          chatHistory.push({
            type: 'user',
            message: messageContent,
          });
        }
      } else {
        // Save bot messages and buttons
        const botMessages = Array.from(
          messageBlock.querySelectorAll('.bot-message')
        ).map((botMessage) => botMessage.innerHTML);

        let buttons = [];
        if (messageBlocks.length === index + 1) {
          buttons = Array.from(
            chatMessages.querySelectorAll('.chat-button')
          ).map((button) => ({
            name: button.textContent,
            request: JSON.parse(button.getAttribute('data-request')),
          }));
        }

        if (botMessages.length > 0) {
          if (buttons.length > 0) buttonsAdded = true;
          chatHistory.push({
            type: 'bot',
            messages: botMessages,
            buttons: buttons.length > 0 ? buttons : undefined,
          });
        } // Save product cards if present

        const productCardsContainer = messageBlock.querySelector(
          '.bot-product-cards-container'
        );

        if (productCardsContainer) {
          const productCards = Array.from(
            productCardsContainer.querySelectorAll('.bot-product-card')
          ).map((card) => ({
            type: 'product_card',
            title: card.querySelector('.product-title').textContent,
            price: card
              .querySelector('.product-price')
              .textContent.replace(/^\$/, '')
              .trim(),
            description: card.querySelector('.chatbot-product-description')
              .textContent,
            image: card.querySelector('.chatbot-product-image').src,
            variantId: card
              .querySelector('.bot-add-to-cart-btn')
              .getAttribute('data-variant-id'),
            total_reviews:
              parseInt(
                card
                  .querySelector('.product-review')
                  .textContent.replace(/[()]/g, ''),
                10
              ) || 0,
            product_score:
              parseFloat(
                card
                  .querySelector('.product-stars')
                  .getAttribute('data-product-score')
              ) || 0,
          }));

          chatHistory.push({
            type: 'product_cards',
            payload: productCards,
            buttons:
              buttons.length > 0 &&
              messageBlocks.length === index + 1 &&
              !buttonsAdded
                ? buttons
                : undefined,
          });
        }
      }
    }); // Save to sessionStorage

    sessionStorage.setItem('chatHistory', JSON.stringify(chatHistory));

    saveTranscript();
  }

  async function loadChatHistory(chatHistory) {
    let buttonContainer = null;
    let previousMessageBlock = null;
    for (const item of chatHistory) {
      if (item.type === 'user') {
        addUserMessage(item.message, true);
      } else if (item.type === 'bot') {
        const botContainer = document.createElement('div');
        botContainer.classList.add('bot-content'); // Create a single message-block for bot messages

        const messageBlock = document.createElement('div');
        messageBlock.classList.add('message-block');
        previousMessageBlock = messageBlock; // Add bot icon
        const botIconContainer = document.createElement('div');
        botIconContainer.classList.add('bot-icon-container');
        botIconContainer.innerHTML = `<img src="${window.botIconUrl}" alt="Bot Icon" class="bot-icon">`;
        botContainer.appendChild(botIconContainer); // Add bot messages

        const botMessages = document.createElement('div');
        botMessages.classList.add('bot-messages');

        item.messages.forEach((message) => {
          const botMessage = document.createElement('div');
          botMessage.classList.add('bot-message');
          botMessage.innerHTML = message;
          botMessages.appendChild(botMessage);
        });

        botContainer.appendChild(botMessages);

        messageBlock.appendChild(botContainer); // Add buttons if present

        if (item.buttons) {
          buttonContainer = document.querySelector('.button-container');

          item.buttons.forEach((button) => {
            const chatButton = document.createElement('button');
            chatButton.classList.add('chat-button');
            chatButton.textContent = button.name;
            chatButton.onclick = () =>
              selectCustomer(button.request, button.name);
            buttonContainer.appendChild(chatButton);
          });
        } // Append the message block to the chat messages container

        document.querySelector('.chat-messages').appendChild(messageBlock);
      } else if (item.type === 'product_cards') {
        // Render product cards
        const productCardsContainer = await renderProductCards(item.payload);
        if (previousMessageBlock) {
          previousMessageBlock.appendChild(productCardsContainer);
        } else {
          const messageBlock = document.createElement('div');
          messageBlock.classList.add('message-block');
          messageBlock.appendChild(productCardsContainer);
          document.querySelector('.chat-messages').appendChild(messageBlock);
        }
        if (item.buttons) {
          buttonContainer = document.querySelector('.button-container');

          item.buttons.forEach((button) => {
            const chatButton = document.createElement('button');
            chatButton.classList.add('chat-button');
            chatButton.textContent = button.name;
            chatButton.onclick = () =>
              selectCustomer(button.request, button.name);
            buttonContainer.appendChild(chatButton);
          });
        }
      }
    }
    if (buttonContainer)
      document.querySelector('.chat-messages').appendChild(buttonContainer); // Scroll to the bottom of the chat

    const chatContent = document.querySelector('.chat-content');
    chatContent.scrollTop = chatContent.scrollHeight;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === 'chat-bot') {
      return;
    }

    const chatContent = document.querySelector('.chat-messages');
    if (chatContent)
      chatContent.innerHTML = `<div class="button-container"></div>`;

    var chatHistory = JSON.parse(sessionStorage.getItem('chatHistory')) || [];
    if (chatHistory.length > 0) {
      loadChatHistory(chatHistory);
    }
  });

  function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0; // Generate random hex value
        const v = c === 'x' ? r : (r & 0x3) | 0x8; // Ensure 'y' follows GUID variant rules
        return v.toString(16);
      }
    );
  }

  const chatbotContainer = document.querySelector('#chatbot-container');

  // Prevent background scrolling when interacting with the chatbot

  function disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }
  function enableBodyScroll() {
    document.body.style.overflow = '';
  } // Activate scroll lock when mouse enters the chatbot
  chatbotContainer.addEventListener('mouseenter', disableBodyScroll);
  chatbotContainer.addEventListener('mouseleave', enableBodyScroll);
  // // For touch devices (mobile)
  // chatbotContainer.addEventListener('touchstart', disableBodyScroll, { passive: false });
  // chatbotContainer.addEventListener('touchend', enableBodyScroll, { passive: false });

  window.addEventListener('beforeunload', async (event) => {
    await saveTranscript();
  });

  // On page load, launch the chatbot and update the UI
  window.onload = function () {
    let userId = JSON.parse(sessionStorage.getItem('voiceFlowuserID')) || '';
    if (userId == '')
      sessionStorage.setItem('voiceFlowuserID', JSON.stringify(generateGUID()));
    const chatbotToggleButton = document.getElementById(
      'chatbot-toggle-button'
    );
    const chatbotContainer = document.getElementById('chatbot-container');
    const notificationBadge = document.querySelector('.notification-badge');

    notificationBadge.classList.remove('hidden');
    handleUserInput();
    var chatHistory = JSON.parse(sessionStorage.getItem('chatHistory')) || [];
    if (chatHistory.length > 0) {
      isRefreshSession = true;
      loadChatHistory(chatHistory).then(() => {
        chatbotToggleButton.style.opacity = '1';
        chatbotToggleButton.style.pointerEvents = 'auto';
      });
    } else {
      chatbotToggleButton.style.opacity = '1';
      chatbotToggleButton.style.pointerEvents = 'auto';
      let loader = getLoader();
      toggleChatInput(true);
      const botMessages = document.createElement('div');
      botMessages.classList.add('bot-messages', 'loading');

      const messageBlock = createLoaderItem(loader, botMessages);
      console.log('user', window.loggedInUser?.email);
      const variable = {
        variables: {
          email_address: window.loggedInUser?.email ?? '',
        },
      };
      interactWithVoiceflow(
        { type: 'launch' }, // First argument: action
        {}, // Second argument: config (empty object)
        variable // Third argument: state
      ).then(function (response) {
        if (response) {
          setTimeout(() => {
            updateChatUI(response, messageBlock).then(() =>
              toggleChatInput(false)
            );
            botMessages.classList.add('loaded'); // Trigger fade-in animation
          }, 500);
        }
      });
    }

    chatbotToggleButton.addEventListener('click', () => {
      window.dataLayer?.push({
        event: 'bot_open',
        bot_name: 'Chatbot X',
      });
      if (!chatbotContainer.classList.contains('active')) {
        window.dataLayer?.push({
          event: 'bot_impression',
          bot_name: 'Chatbot X',
        });
        chatbotContainer.classList.toggle('active');
        disableBodyScroll();
        notificationBadge.classList.add('hidden');
      } else {
        chatbotContainer.classList.remove('active');
        // enableBodyScroll()
      }
    });
  };
})();
